import React from 'react';

interface Props {
    items: React.ReactNodeArray;
    activeStep: number;
    animation?: 'slide-in' | 'fade-in';
}

const CarouselItems = ({ activeStep, items, animation = 'slide-in' }: Props) => {
    const slideInStyleForItems = {
        transform: activeStep == 0 ? 'none' : `translateX(-${activeStep * 100}%)`,
    };

    return (
        <div
            data-testid="carousel-items"
            className="carousel__items"
            style={animation == 'slide-in' ? slideInStyleForItems : undefined}
            role="list"
        >
            {items.map((item, index) => {
                const slideInStyleForItem = {
                    transform: index == 0 ? 'none' : `translateX(${index * 100}%)`,
                };

                return (
                    <div
                        data-testid="carousel-items__item"
                        className="carousel__item"
                        key={`carousel-item-${index}`}
                        role="listitem"
                        data-active={index == activeStep ? '' : undefined}
                        style={animation == 'slide-in' ? slideInStyleForItem : undefined}
                    >
                        {item}
                    </div>
                );
            })}
        </div>
    );
};

export default CarouselItems;
